// extracted by mini-css-extract-plugin
module.exports = {"bonus":"_62a505e","bonusImage":"_2e24f95"};